import OCV from "./ocv";

// Loaded by @primevue/nuxt-module `importTheme` (nuxt.config.ts): the preset ships in the
// JS bundle instead of being serialized into runtimeConfig, i.e. into the HTML shell.
export default {
  preset: OCV,
  options: {
    cssLayer: {
      name: "primevue",
      order: "tailwind-base, primevue, tailwind-utilities",
    },
    darkModeSelector: ".dark",
  },
};
